import request from './request'
import requestTask from './super-task'
/**
 * 针对请求次数多的接口采用 requestTask 并发处理
 * 如：商品更新接口 首页推荐分类板块数据
 */

/**
 * 获取推荐分类
 * @param {Object} data {type:1=置顶分类，2=推荐分类，limit:数量}
 */
export function getTopCate(data = {}) {
  return requestTask({
    url: '/manager/Choice/getTopCate',
    data
  })
}

/**
 * 获取推荐商品
 * @param {Object} data {
   page 页码;
   limit 数量;
   site 推荐位置，1=首页;
   supply_type 渠道ID，传值即取对应渠道ID置顶商品;
   cate_id 分类ID，传值即取对应分类ID置顶商品
 }
 */
export function getTopGoods(data = {}) {
  return requestTask({
    url: '/manager/Choice/getTopGoods',
    data
  })
}

/**
 * 获取分类热销榜
 * @param {Object} data {
   page 页码;
   limit 数量;
   site 推荐位置，1=首页;
   supply_type 渠道ID，传值即取对应渠道ID置顶商品;
   cate_id 分类ID，传值即取对应分类ID置顶商品
 }
 */
export function getHotGoods(data = {}) {
  return requestTask({
    url: '/manager/Choice/getHotGoods',
    data
  })
}

/**
 * 获取渠道列表
 */
export function getSupply(data = {}) {
  return request({
    url: '/manager/Choice/getSupply',
    data
  })
}

/**
 * 获取品牌列表
 * @param {Object} data {
   page 页码;
   limit 数量;
   group_id 所属分类组，与分类互斥;
   cate_id 所属分类ID，与分类组互斥
 }
 */
export function getBrand(data = {}) {
  return request({
    url: '/manager/Choice/getBrand',
    data
  })
}

/**
 * 广告图
 * @param {Object} data {
   limit 数量;
   type 使用位置，1=首页，2=列表页，3=专题页;
   navi 导航ID;
 }
 */
export function getRecommendBit(data = {}) {
  return request({
    url: '/manager/Choice/getRecommendBit',
    data
  })
}

/**
 * 轮播图
 * @param {Object} data {type: 1=首页，2=列表页，3=专题页 4=权益充值，navi:专题页时为专题页ID，limit:限制数量5}
 */
export function getBannerImg(data = {}) {
  return request({
    url: '/manager/Choice/getBannerImg',
    data
  })
}

/**
 * 获取商品列表
 * @param {Object} data {
   page 页码;
   limit 数量;
   nav_type 1固定导航，2活动导航;
   nav_id 导航栏ID;
   type 0不搜索，1搜名称，2搜编码;
   spu_name 商品名称;
   spu_sn 商品编码;
   supply_type 渠道ID;
   cate_group_id 分类组筛选传下属分类ID;
   cate_id 分类ID，分类组传值优先;
   brand_id 品牌ID;
   min_plat 最小成本价;
   max_plat 最大成本价;
   min_profit 最小利润率;
   max_profit 最大利润率;
   min_price 最小零售价;
   max_price 最大零售价;
   min_discount 最小折扣;
   max_discount 最大折扣;
   sort_field 排序字段，1利润率，2零售价，3成本价;
   sort_desc 排序方式，1降序（箭头向下），2升序;
   status 1=上架;
 }
 */
export function getGoodsList(data = {}) {
  return request({
    url: '/manager/Choice/getGoodsList',
    data
  })
}

/**
 * 获取权益充值
 * @param {Object} data {spu_name:商品名称，2=获取下架商品， page:页，limit:数量}
 */
export function getVirtualGoodsList(data = {}) {
  return requestTask({
    url: '/manager/choice/getVirtualGoodsList',
    data
  })
}

/**
 * 权益充值立即购买
 * @param {Object} data {goods_id:商品id，receiver:充值账户，third_order_no:下游订单号}
 */
export function virtualSubmit(data = {}) {
  return request({
    url: '/manager/choice/virtualSubmit',
    data
  })
}

/**
 * 更新商品
 * @param {Object} data {goods_id: 商品id}
 */
export function updateGoods(data = {}) {
  return requestTask({
    url: '/manager/Choice/updateGoods',
    data
  })
}

/**
 * 选品库变动 查询统计 加入选品 移除选品
 * @param {Object} data {type: 0=查询，1=新增，2=删除，goods_id: 商品ID,可多个}
 */
export function updateChoice(data = {}) {
  return request({
    url: '/manager/Choice/updateChoice',
    data
  })
}

/**
 * 虚拟商品选品库变动
 * @param {Object} data {type: 0=查询，1=新增，2=删除，goods_id: 商品ID,可多个}
 */
export function updateVirtualChoice(data = {}) {
  return request({
    url: '/manager/choice/updateVirtualChoice',
    data
  })
}

/**
 * 加入购物车
 * @param {Object} data {sku_id}
 */
export function addCart(data = {}) {
  return request({
    url: '/manager/QuickOrder/add_cart',
    data
  })
}

/**
 * 移除购物车
 * @param {Object} data {cart_id}
 */
export function delCart(data = {}) {
  return request({
    url: '/manager/QuickOrder/del_cart',
    data
  })
}

/**
 * 获取分类组列表
 * @param {Object} data {page: 页，limit:数量}
 */
export function getCateGroup(data = {}) {
  return request({
    url: '/manager/Choice/getCateGroup',
    data
  })
}

/**
 * 获取二级分类
 * @param {Object} data {group_id: 分类组id 优先，cate_pid: 一级分类id}
 */
export function getCategory(data = {}) {
  return request({
    url: '/manager/Choice/getCategory',
    data
  })
}

/**
 * 获取导航列表
 * @param {Object} data {无}
 */
export function getNavbar(data = {}) {
  return request({
    url: '/manager/Choice/getNavbar',
    data
  })
}

/**
 * 获取商品详情
 * @param {Object} data {goods_id:商品ID，page:页码，limit:数量}
 */
export function getGoodsDetail(data = {}) {
  return request({
    url: '/manager/Choice/getGoodsDetail',
    data
  })
}

/**
 * 获取虚拟商品详情
 * @param {Object} data {goods_id:商品ID}
 */
export function getVirtualGoodsDetail(data = {}) {
  return request({
    url: '/manager/choice/getVirtualGoodsDetail',
    data
  })
}

/**
 * 获取配送地址运费
 * @param {Object} data {goods_id:渠道ID,region_id:上级地址ID}
 */
export function getRegionPrice(data = {}) {
  return request({
    url: '/manager/Choice/getRegionPrice',
    data
  })
}

/**
 * 获取配送地址
 * @param {Object} data {supply_type:渠道ID,region_pid:上级地址ID}
 */
export function getRegion(data = {}) {
  return request({
    url: '/manager/Choice/getRegion',
    data
  })
}

/**
 * 获取购物车数据
 */
export function getCart(data = {}) {
  return request({
    url: '/manager/QuickOrder/index',
    data
  })
}

/**
 * 更改购物车数量
 * @param {Object} data {cart_id:购物车id,number:商品数量}
 */
export function setCartNum(data = {}) {
  return request({
    url: '/manager/QuickOrder/set_cart_num',
    data
  })
}

/**
 * 购物车下单
 * @param {Object} data {accessToken}
 */
export function submitOrderCart(data = {}) {
  return request({
    url: '/manager/QuickOrder/order_cart',
    data
  })
}

/**
 * 支付
 * @param {Object} data {cart_id:购物车id,address_id:地址id,password:支付密码}
 */
export function payOrder(data = {}) {
  return request({
    url: '/manager/QuickOrder/order_pay',
    data
  })
}

/**
 * 获取收货地址
 */
export function getAddList(data = {}) {
  return request({
    url: '/manager/QuickOrder/add_list',
    data
  })
}

/**
 * 删除收货地址
 * @param {Object} data {address_id:地址id,多个地址用逗号隔开}
 */
export function delAddress(data = {}) {
  return request({
    url: '/manager/QuickOrder/add_del',
    data
  })
}

/**
 * 获取省市区
 * @param {Object} data {pid:上级id}
 */
export function getRegionsList(data = {}) {
  return request({
    url: '/manager/index/getRegions',
    data
  })
}

/**
 * 获取顶部热搜词
 * @param {Object} data {cate_id:栏目ID，默认为0则取所有关键字，limit:数量}
 */
export function getHotSearch(data = {}) {
  return request({
    url: '/manager/Choice/getHotSearch',
    data
  })
}

/**
 * 获取用户信息
 */
export function getUserInfo(data = {}) {
  return request({
    url: '/manager/Choice/getUserInfo',
    data
  })
}

/**
 * 资源下载
 * @param {Object} data {goods_id:商品id}
 */
export function downGoods(data = {}) {
  return request({
    url: '/manager/Choice/downGoods',
    data
  })
}

/**
 * 现在收货地址
 * @param {Object} data {goods_id:商品id}
 */
export function addAddress(data = {}) {
  return request({
    url: '/manager/QuickOrder/add_address',
    data
  })
}
/**
 * 设置默认收货地址
 * @param {Object} data {goods_id:商品id}
 */
export function setaDefaultAdd(data = {}) {
  return request({
    url: '/manager/QuickOrder/set_default_add',
    data
  })
}

/**
 * 获取自定义标签
 * @param {Object} data {goods_id:商品id}
 */
export function getGoodsTag(data = {}) {
  return request({
    url: '/manager/Choice/getGoodsTag',
    data
  })
}

/**
 * 获取虚拟商品分类
 * @param {Object} data {goods_id:商品id}
 */
export function getVirtualCategory(data = {}) {
  return request({
    url: '/manager/choice/getVirtualCategory',
    data
  })
}
/**
 * 获取虚pe
 * @param {Object} data {goods_id:商品id}
 */
export function getSysInfo(data = {}) {
  return request({
    url: '/manager/choice/getSysInfo',
    data
  })
}
/**
 * 获取城市列表(本地生活)
 */
export function getCityList(data) {
  return request({
      url: '/manager/Life/getCityList',
      method: 'post',
      data
  })
}
/**
 * 获取分类(本地生活)
 */
export function getCateList(data) {
  return request({
      url: '/manager/Life/getCateList',
      method: 'post',
      data
  })
}
/**
 * 获取品牌(本地生活)
 */
export function getBrandList(data) {
  return request({
      url: '/manager/Life/getBrandList',
      method: 'post',
      data
  })
}
/**
 * 极速支付
 */
export function quickPay(data) {
  return request({
      url: '/manager/Choice/quickPay',
      method: 'post',
      data
  })
}
/**
 * 获取品牌(本地生活)
 */
export function submitOrder(data) {
  return request({
      url: '/manager/Choice/submitOrder',
      method: 'post',
      data
  })
}
/**
 * 优惠券
 */
export function couponList(data) {
  return request({
      url: '/manager/QuickOrder/couponList',
      method: 'post',
      data
  })
}
/**
 * 商品检查
 */
export function goodsCommon(data) {
  return request({
      url: '/manager/Choice/goodsCommon',
      method: 'post',
      data
  })
}
/**
 * 集采
 */
export function purchase(data) {
  return request({
      url: '/manager/Choice/purchase',
      method: 'post',
      data
  })
}
/**
 * 虚拟商品品牌
 */
export function getVirtualBrand(data) {
  return request({
      url: '/manager/choice/getVirtualBrand',
      method: 'post',
      data
  })
}
/**
 * 获取商品列表（抢购）
 */
export function panicGoodsList(data) {
  return request({
      url: '/manager/QiangGou/getGoodsList',
      method: 'post',
      data
  })
}
/**
 * 获取商品详情（抢购）
 */
export function panicGoodsDetail(data) {
  return request({
      url: '/manager/QiangGou/getGoodsDetail',
      method: 'post',
      data
  })
}
/**
 * 获取配送地址运费&库存（抢购）
 */
export function panicRegionPrice(data) {
  return request({
      url: '/manager/QiangGou/getRegionPrice',
      method: 'post',
      data
  })
}
/**
 * 快速下单（抢购）
 */
export function panicQuickPay(data) {
  return request({
      url: '/manager/QiangGou/quickPay',
      method: 'post',
      data
  })
}
/**
 * 订单提交（抢购）
 */
export function panicSubmitOrder(data) {
  return request({
      url: '/manager/QiangGou/submitOrder',
      method: 'post',
      data
  })
}
/**
 * 生成二维码
 */
export function mobileQrcode(data) {
  return request({
      url: '/manager/choice/mobileQrcode',
      method: 'post',
      data
  })
}
/**
 * 不包邮商品地区检测
 */
export function freight_inspection(data) {
  return request({
      url: '/manager/Choice/freight_inspection',
      method: 'post',
      data
  })
}
/**
 * 获取商品不包邮地区
 */
export function free_shipping(data) {
  return request({
      url: '/manager/Choice/free_shipping',
      method: 'post',
      data
  })
}
/**
 * 查询余额
 */
export function getBalance(data) {
  return request({
      url: '/manager/Choice/getBalance',
      method: 'post',
      data
  })
}
/**
 * 获取单个sku实时数据
 */
export function getSkuDetail(data) {
  return request({
      url: '/manager/Choice/getSkuDetail',
      method: 'post',
      data
  })
}
/**
 * 获取购物车实时数据
 */
export function cartSkuReal(data) {
  return request({
      url: '/manager/QuickOrder/cartSkuReal',
      method: 'post',
      data
  })
}
/**
 * 一键加入选品库
 */
export function updateChoiceAll(data) {
  return request({
      url: '/manager/Choice/updateChoiceAll',
      method: 'post',
      data
  })
}
/**
 * 注册弹窗
 */
export function loginRegion(data) {
  return request({
      url: '/manager/login/region',
      method: 'post',
      data
  })
}
/**
 * 注册弹窗
 */
export function send(data) {
  return request({
      url: 'manager/login/send',
      method: 'post',
      data
  })
}
/**
 * 更多商品
 */
export function getLinkGoods(data) {
  return request({
      url: 'manager/Choice/getLinkGoods',
      method: 'post',
      data
  })
}
/**
 * 广告位置
 */
export function getRecsSpecial(data) {
  return request({
      url: 'manager/Choice/getRecsSpecial',
      method: 'post',
      data
  })
}
/**
 * 广告
 */
export function getLink(data) {
  return request({
      url: 'manager/choice/getLink',
      method: 'post',
      data
  })
}
/**
 * 导航（新）
 */
export function getNaviSpecial(data) {
  return request({
      url: 'manager/choice/getNaviSpecial',
      method: 'post',
      data
  })
}
/**
 * banner商品(新)
 */
export function getTopSpecial(data) {
  return request({
      url: 'manager/choice/getTopSpecial',
      method: 'post',
      data
  })
}
/**
 * 清除缓存
 */
export function clearCache(data) {
  return request({
      url: 'manager/choice/clearCache',
      method: 'post',
      data
  })
}
